'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

export default function Home() {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    // Prevent re-running on route changes
    if (hasChecked) return;


    if (!isLoading) {
      if (isAuthenticated) {
        router.replace('/home');
      } else {
        // Redirect new/unauthenticated users to onboarding flow
        const onboardingSeen = localStorage.getItem('onboardingSeen');
        if (onboardingSeen) {
          router.replace('/login');
        } else {
          router.replace('/joydrop-moments');
        }
      }
      setHasChecked(true);
    }
  }, [isAuthenticated, isLoading, router, hasChecked]);

  // Show a minimal loading state while redirecting
  return (
    <div className="min-h-screen bg-[#12100F] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F5F0E8] mx-auto"></div>
        <p className="mt-4 text-[#8A7F74]">Loading...</p>
      </div>
    </div>
  );
}
